import { Routes, Route, Navigate } from 'react-router-dom';
import TrackStatusSingle from '../Views/TrackStatus/trackStatusSingle';
import Home from '../Views/Home/home';
import RaiseRequest from '../Views/RaiseRequest/_RaiseRequest';
import ManageAccount from '../Views/ManageAccount/ManageAccount';
import PersonalInfo from '../Views/ManageAccount/PersonalInfo/PersonalInfo';
import Addressess from '../Views/ManageAccount/Addressess/Addressess';
import ContactUs from '../Views/ContactUs/ContactUs';
import Appointment from '../Views/Appointment/Appointment';
import CheckAppointment from '../Views/Appointment/CheckAppointment';
import Machines from '../Views/ManageAccount/Machines/Machines';
import ChatWithTechnician from '../Views/TrackStatus/chatWithTechnician';
// import CartModal from '../components/CartModal/CartModel';
// import AmcHome from '../Views/Amc/Amc';
// import MyLoyalty from '../Views/MyLoyalty/MyLoyalty';
// import RewardHistory from '../Views/MyLoyalty/RewardHistory';
// import TrackOrderHome from '../Views/TrackOrder/TrackOrderHome';
// import TrackSingleOrder from '../Views/TrackOrder/TrackSingleOrder';
// import CartHome from '../Views/Cart/CartHome';
// import Product from '../Views/Product/Product';
// import SelectAddress from '../Views/Cart/SelectAddress';
// import SelectAddressModal from '../components/SelectAddressModal/SelectAddressModal';
// import OffersList from '../Views/Cart/Offers/OffersList';
// import SelectPaymentMethod from '../Views/Cart/SelectPaymentMethod';

export default function AuthRouter() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/raise-request" element={<RaiseRequest />} />
        <Route path="/track-status" element={<TrackStatusSingle />} />
        <Route path="/track-status/chat" element={<ChatWithTechnician />} />
        {/* <Route path="/loyalty" element={<MyLoyalty />} /> */}
        {/* <Route path="/loyalty/activity" element={<RewardHistory />} /> */}
        <Route path="/manage-account" element={<ManageAccount />} />
        <Route path="/manage-account/personal-info" element={<PersonalInfo />} />
        <Route path="/manage-account/addresses" element={<Addressess />} />
        <Route path="/manage-account/machines" element={<Machines />} />
        <Route path="/contact-us" element={<ContactUs />} />
        {/* <Route path="/amc" element={<AmcHome />} /> */}
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/check-appointment" element={<CheckAppointment />} />
        {/* <Route path="/cart" element={<CartHome />} /> */}
        {/* <Route path="/cart/offers" element={<OffersList />} /> */}
        {/* <Route path="/cart/selectAddress" element={<SelectAddress />} /> */}
        {/* <Route path="/cart/selectpaymentoption" element={<SelectPaymentMethod />} /> */}
        {/* <Route path="/product/:sap_code" element={<Product />} /> */}
        {/* <Route path="/track-order" element={<TrackOrderHome />} /> */}
        {/* <Route path="/track-order/:id" element={<TrackSingleOrder />} /> */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      {/* <CartModal />
      <SelectAddressModal /> */}
    </>
  );
}
